import { accountApi } from "./accountApi";
import { categorySourceApi } from "./categorySourceApi";
import { crmHocSinhApi } from "./crmHocSinhApi";
import { dictionaryApi } from "./dictionaryApi";
import { foCaAnApi } from "./foCaAnApi";
import { foCaAnTruongApi } from "./foCaAnTruongApi";
import { foMonAnChiTietApi } from "./foMonAnChiTietApi";
import { foThucDonApi } from "./foThucDonApi";
import { foDotDangKyAnApi } from "./foDotDangKyAnApi";
import { foDotDangKyPhamViApi } from "./foDotDangKyPhamViApi";
import { foDangKyAnHocSinhApi } from "./foDangKyAnHocSinhApi";
import { hocSinhApi } from "./hocSinhApi";
import { localizedReourceApi } from "./localizedReourceApi";
import { lopApi } from "./lopApi";
import { notifyApi } from "./notifyApi";
import { uploadApi } from "./uploadApi";
import { ngayNghiApi } from "./ngayNghiApi";
import { trangThaiDangKyAnApi } from "./trangThaiDangKyAnApi";

export const apiWrapper = {
  account: accountApi,
  uploadFile: uploadApi,
  categorySource: categorySourceApi,
  dictionary: dictionaryApi,
  lop: lopApi,
  hocSinh: hocSinhApi,
  notify: notifyApi,
  localizedResource: localizedReourceApi,

  crmHocSinh: crmHocSinhApi,
  thucDonWrapper: {
    caAn: foCaAnApi,
    caAnTruong: foCaAnTruongApi,
    monAnChiTiet: foMonAnChiTietApi,
    thucDon: foThucDonApi,
    dotDangKyAn: foDotDangKyAnApi,
    dotDangKyPhamVi: foDotDangKyPhamViApi,
    dangKyAnHocSinh: foDangKyAnHocSinhApi,
  },
  ngayNghi: ngayNghiApi,
  trangThaiDangKyAn: trangThaiDangKyAnApi,
};
